module.exports = __webpack_public_path__ + "img/6e4ca6e.jpg";